export function getModelUrl({
  modelRepositoryId,
}: {
  modelRepositoryId: string;
}) {
  if (modelRepositoryId) {
    return `/dashboard/${modelRepositoryId}`;
  }
  return "/dashboard";
}
